import React, { Fragment } from 'react';

import Link from '../../../tailwind/Link';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

interface Props {
  /** The array of social media network objects. */
  data: {
    /** The label of the social media network. */
    label: string;
    /** The URL of the social media network. */
    value: string;
  }[];
}

const SocialLinksMessage = ({ data }: Props) => {
  const { tt } = useUiComponentsInternationalContext();

  if (!data?.length) return null;

  const linksComponents = data?.map(network => (
    <Link
      key={network.label}
      className="text-brand-foreground ml-1 capitalize hover:underline"
      link={{ href: network.value, linkType: 'external', blank: true }}
    >
      {network.label}
    </Link>
  ));

  const lastLink = linksComponents?.pop();

  return (
    <div className="inline-flex pl-2 flex-wrap justify-center font-bold">
      <span>{tt(s => s.socialLinksMessageComponent.followUsLabel)}</span>
      {linksComponents?.map((link, index) => (
        <Fragment key={link.key}>
          {link}
          {index < linksComponents.length - 1 && <span>,</span>}
        </Fragment>
      ))}
      {linksComponents?.length > 1 && <span className="ml-2">&</span>}
      {lastLink}
      <span className="ml-2">#PetSafe</span>
    </div>
  );
};

export default SocialLinksMessage;
